import { Flex } from 'antd'
import type { CSSProperties, ReactNode } from 'react'

import { useStyles } from './styles'

type Props = {
  /** Right-aligned primary actions (Save, Submit). */
  children: ReactNode
  /** Left-aligned secondary actions (Reset, Cancel, helper text). */
  start?: ReactNode
  /**
   * Stick to the viewport bottom. Defaults to true — the common case for
   * long forms where the action area must stay reachable while scrolling.
   */
  sticky?: boolean
  className?: string
  style?: CSSProperties
}

/**
 * Footer for form actions (Save / Reset / Cancel). Centralises padding,
 * border, background, and sticky behaviour so individual screens cannot
 * forget an axis or drift from the rest of the app.
 */
export const FormActionsBar = ({
  children,
  start,
  sticky = true,
  className,
  style
}: Props) => {
  const { styles, cx } = useStyles()

  return (
    <div
      className={cx(styles.bar, sticky && styles.sticky, className)}
      style={style}
    >
      <Flex align="center" justify="space-between" gap={12}>
        <div className={styles.start}>{start}</div>
        <Flex align="center" gap={8}>
          {children}
        </Flex>
      </Flex>
    </div>
  )
}
